import IconRipple from '../RippleIcon';
import { MoonStar, Sun, Sunrise, Sunset } from 'lucide-react';
import dayjs from 'dayjs';
import { t } from '~/services/i18n';

function getGreetingLabel() {
    const hour = dayjs().hour();

    if (hour >= 5 && hour < 12) {
        return (
            <>
                <IconRipple iconSize={35} icon={Sunrise} />
                {t('greetingLabel.morning', 'Good morning')}
            </>
        );
    } else if (hour >= 12 && hour < 17) {
        return (
            <>
                <IconRipple spin={true} iconSize={35} icon={Sun} />
                {t('greetingLabel.afternoon', 'Good afternoon')}
            </>
        );
    } else if (hour >= 17 && hour < 21) {
        return (
            <>
                <IconRipple iconSize={35} icon={Sunset} />
                {t('greetingLabel.evening', 'Good evening')}
            </>
        );
    } else {
        return (
            <>
                <IconRipple iconSize={35} icon={MoonStar} />
                {t('greetingLabel.night', 'Good night')}
            </>
        );
    }
}

export default function LoadingAnimation() {
    return (
        <div className='w-full h-full flex flex-col items-center justify-center'>
            <h3 className='text-xl flex flex-row gap-2 items-center font-semibold text-gray-400 mb-8'>
                {getGreetingLabel()}
            </h3>
        </div>
    );
}
